 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import BACK_COVER_TEXT from '@/components/Back_Cover_Text'
 import PRAISE from '@/components/Praise'
 import BOOKLIST from '@/components/Booklist'
 import TITLE_PAGE from '@/components/Title_Page'
 import DEDICATION from '@/components/Dedication'
 import MAP from '@/components/Map'
 import CONTENTS from '@/components/Contents'
 import DAY_ONE from '@/components/Day_One'
 import ENNE from '@/components/Enne'
 import LEVI from '@/components/Levi'
 import LEVI1 from '@/components/Levi-1'
 import ENNE1 from '@/components/Enne-1'
 import ENNE2 from '@/components/Enne-2'
 import LEVI2 from '@/components/Levi-2'
 import ENNE3 from '@/components/Enne-3'
 import ENNE4 from '@/components/Enne-4'
 import DAY_TWO from '@/components/Day_Two'
 import LEVI3 from '@/components/Levi-3'
 import ENNE5 from '@/components/Enne-5'
 import LEVI4 from '@/components/Levi-4'
 import ENNE6 from '@/components/Enne-6'
 import DAY_THREE from '@/components/Day_Three'
 import LEVI5 from '@/components/Levi-5'
 import ENNE7 from '@/components/Enne-7'
 import DAY_FOUR from '@/components/Day_Four'
 import LEVI6 from '@/components/Levi-6'
 import ENNE8 from '@/components/Enne-8'
 import DAY_FIVE from '@/components/Day_Five'
 import ENNE9 from '@/components/Enne-9'
 import DAY_SIX from '@/components/Day_Six'
 import LEVI7 from '@/components/Levi-7'
 import ENNE10 from '@/components/Enne-10'
 import LEVI8 from '@/components/Levi-8'
 import DAY_SEVEN from '@/components/Day_Seven'
 import ENNE11 from '@/components/Enne-11'
 import DAY_EIGHT from '@/components/Day_Eight'
 import ENNE12 from '@/components/Enne-12'
 import LEVI9 from '@/components/Levi-9'
 import DAY_NINE from '@/components/Day_Nine'
 import ENNE13 from '@/components/Enne-13'
 import LEVI10 from '@/components/Levi-10'
 import LEVI11 from '@/components/Levi-11'
 import ENNE14 from '@/components/Enne-14'
 import LEVI12 from '@/components/Levi-12'
 import ENNE15 from '@/components/Enne-15'
 import DAY_TEN from '@/components/Day_Ten'
 import ENNE16 from '@/components/Enne-16'
 import LEVI13 from '@/components/Levi-13'
 import ENNE17 from '@/components/Enne-17'
 import LEVI14 from '@/components/Levi-14'
 import EPILOGUE from '@/components/Epilogue'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import EXCERPT from '@/components/Excerpt'
 import COPYRIGHT from '@/components/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Day_One",
 			"name" : "Day_One",
 			"component" : DAY_ONE
 		},
 		{
 			"path" : "/Enne",
 			"name" : "Enne",
 			"component" : ENNE
 		},
 		{
 			"path" : "/Levi",
 			"name" : "Levi",
 			"component" : LEVI
 		},
 		{
 			"path" : "/Levi-1",
 			"name" : "Levi-1",
 			"component" : LEVI1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js